(function () {
  function initSection(section) {
    if (!section || section.dataset.d7PeekVideoReady === 'true') return;
    section.dataset.d7PeekVideoReady = 'true';

    var modal = section.querySelector('[data-d7-peek-video-modal]');
    var media = section.querySelector('[data-d7-peek-video-media]');
    var closeButtons = section.querySelectorAll('[data-d7-peek-video-close]');
    var prevButton = section.querySelector('[data-d7-peek-video-prev]');
    var nextButton = section.querySelector('[data-d7-peek-video-next]');
    var soundButton = section.querySelector('[data-d7-peek-video-sound]');
    var soundOff = section.querySelector('[data-d7-peek-video-sound-off]');
    var soundOn = section.querySelector('[data-d7-peek-video-sound-on]');
    var productCard = section.querySelector('[data-d7-peek-video-product]');
    var activeVideo = null;
    var activeIndex = 0;
    var muted = true;

    if (!modal || !media) return;

    function getSlides() {
      var seen = {};
      return Array.prototype.slice.call(section.querySelectorAll('[data-d7-peek-video-slide]')).filter(function (slide) {
        var key = slide.dataset.blockId || '';
        if (!key) return true;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function normalizeSourceType(url, type) {
      if (type && type.indexOf('/') > -1) return type;
      if (/\.webm(\?.*)?$/i.test(url)) return 'video/webm';
      if (/\.(mp4|m4v|mov)(\?.*)?$/i.test(url)) return 'video/mp4';
      return type || '';
    }

    function isDirectVideoUrl(url) {
      return /\.(mp4|m4v|mov|webm)(\?.*)?$/i.test(url || '');
    }

    function canPlaySource(video, source) {
      if (!source.type) return true;
      return video.canPlayType(source.type) !== '';
    }

    function getText(root, selector) {
      var node = root ? root.querySelector(selector) : null;
      return node ? node.textContent.trim() : '';
    }

    function getProduct(slide) {
      var data = slide ? slide.querySelector('[data-d7-peek-video-product-data]') : null;
      if (!data) return null;

      var product = {
        title: getText(data, '[data-d7-peek-video-product-title]'),
        url: getText(data, '[data-d7-peek-video-product-url]'),
        price: getText(data, '[data-d7-peek-video-product-price]'),
        compare: getText(data, '[data-d7-peek-video-product-compare]'),
        image: getText(data, '[data-d7-peek-video-product-image]')
      };

      return product.title && product.url ? product : null;
    }

    function renderProduct(slide) {
      if (!productCard) return;

      var product = getProduct(slide);
      var image = productCard.querySelector('[data-d7-peek-video-product-image-target]');
      var title = productCard.querySelector('[data-d7-peek-video-product-title-target]');
      var price = productCard.querySelector('[data-d7-peek-video-product-price-target]');
      var compare = productCard.querySelector('[data-d7-peek-video-product-compare-target]');

      if (!product) {
        productCard.hidden = true;
        productCard.removeAttribute('href');
        return;
      }

      productCard.href = product.url;
      if (title) title.textContent = product.title;
      if (price) price.textContent = product.price;

      if (compare) {
        compare.textContent = product.compare;
        compare.hidden = !product.compare;
      }

      if (image) {
        if (product.image) {
          image.src = product.image;
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      }

      productCard.hidden = false;
    }

    function chooseBestSource(slide, trigger, video) {
      var sourceNodes = Array.prototype.slice.call(slide.querySelectorAll('[data-d7-peek-video-source]'));
      var shopifySources = sourceNodes
        .map(function (node) {
          var url = node.dataset.d7PeekVideoSourceUrl || '';
          return {
            url: url,
            type: normalizeSourceType(url, node.dataset.d7PeekVideoSourceType || ''),
            height: parseInt(node.dataset.d7PeekVideoSourceHeight || '0', 10) || 0
          };
        })
        .filter(function (source) {
          return source.url && canPlaySource(video, source);
        });

      if (shopifySources.length) {
        var mp4Sources = shopifySources.filter(function (source) {
          return source.type === 'video/mp4' || /\.mp4(\?.*)?$/i.test(source.url);
        });
        var candidates = mp4Sources.length ? mp4Sources : shopifySources;
        var under1080 = candidates.filter(function (source) {
          return source.height > 0 && source.height <= 1080;
        });

        if (under1080.length) {
          under1080.sort(function (a, b) {
            return b.height - a.height;
          });
          return under1080[0];
        }

        candidates.sort(function (a, b) {
          return a.height - b.height;
        });
        return candidates[0];
      }

      var externalUrl = trigger.dataset.d7PeekVideoExternalUrl || '';
      if (!externalUrl || !isDirectVideoUrl(externalUrl)) return null;

      var externalSource = {
        url: externalUrl,
        type: normalizeSourceType(externalUrl, ''),
        height: 0
      };
      return canPlaySource(video, externalSource) ? externalSource : null;
    }

    function clearMedia() {
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.removeAttribute('src');
        activeVideo.querySelectorAll('source').forEach(function (source) {
          source.removeAttribute('src');
          source.removeAttribute('type');
          source.remove();
        });
        activeVideo.load();
        activeVideo.remove();
        activeVideo = null;
      }
      media.textContent = '';
    }

    function renderPoster(poster) {
      if (!poster) return null;
      var image = document.createElement('img');
      image.className = 'creator-page-modal__poster';
      image.src = poster;
      image.alt = '';
      media.appendChild(image);
      return image;
    }

    function renderUnavailable() {
      var message = document.createElement('span');
      message.className = 'creator-page-modal__error';
      message.textContent = 'Video unavailable';
      media.appendChild(message);
    }

    function syncSoundButton() {
      if (!soundButton) return;
      soundButton.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      if (soundOff) soundOff.hidden = !muted;
      if (soundOn) soundOn.hidden = muted;
      if (activeVideo) activeVideo.muted = muted;
    }

    function renderMedia(slide, trigger) {
      clearMedia();
      var poster = trigger.dataset.d7PeekVideoPoster || '';
      var posterImage = renderPoster(poster);
      var video = document.createElement('video');
      var source = chooseBestSource(slide, trigger, video);

      if (!source) {
        renderUnavailable();
        return;
      }

      video.className = 'creator-page-modal__video';
      video.playsInline = true;
      video.muted = muted;
      video.loop = true;
      video.preload = 'metadata';
      video.controls = false;
      if (poster) video.poster = poster;

      var sourceNode = document.createElement('source');
      sourceNode.src = source.url;
      if (source.type) sourceNode.type = source.type;
      video.appendChild(sourceNode);

      video.addEventListener('canplay', function () {
        video.play().catch(function () {});
        video.classList.add('is-ready');
        if (posterImage) posterImage.classList.add('is-hidden');
      });

      video.addEventListener('error', function () {
        if (activeVideo === video) activeVideo = null;
        video.remove();
        renderUnavailable();
      });

      media.appendChild(video);
      activeVideo = video;
      video.load();
    }

    function show(index) {
      var slides = getSlides();
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      var slide = slides[activeIndex];
      var trigger = slide.querySelector('[data-d7-peek-video-open]');
      if (!trigger) return;
      renderMedia(slide, trigger);
      renderProduct(slide);
      syncSoundButton();
    }

    function openFromTrigger(trigger) {
      var slide = trigger.closest('[data-d7-peek-video-slide]');
      var slides = getSlides();
      var blockId = slide ? slide.dataset.blockId : '';
      var index = slides.findIndex(function (item) {
        return blockId && item.dataset.blockId === blockId;
      });
      if (index < 0) index = slides.indexOf(slide);
      muted = true;
      modal.hidden = false;
      document.documentElement.classList.add('creator-page-modal-open');
      show(index > -1 ? index : 0);
    }

    function close() {
      clearMedia();
      muted = true;
      modal.hidden = true;
      if (productCard) productCard.hidden = true;
      document.documentElement.classList.remove('creator-page-modal-open');
      syncSoundButton();
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-d7-peek-video-open]');
      if (!trigger || !section.contains(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      openFromTrigger(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(activeIndex + 1);
      });
    }

    if (soundButton) {
      soundButton.addEventListener('click', function () {
        muted = !muted;
        syncSoundButton();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-d7-peek-video-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('[data-d7-peek-video-section]'));
  });
})();
